const DEFAULT_API_BASE_URL = 'http://localhost:8080';

interface OidcConfig {
  authority: string;
  clientId: string;
  postLogoutRedirectUri: string;
  redirectUri: string;
  scope: string;
}

export const getApiBaseUrl = (): string =>
  process.env.API_BASE_URL || DEFAULT_API_BASE_URL;

const getRequiredEnv = (key: string, value: string | undefined): string => {
  if (!value) {
    throw new Error(`Missing required OIDC config: ${key}`);
  }

  return value;
};

export const getOidcConfig = (): OidcConfig => ({
  authority: getRequiredEnv('OIDC_AUTHORITY', process.env.OIDC_AUTHORITY),
  clientId: getRequiredEnv('OIDC_CLIENT_ID', process.env.OIDC_CLIENT_ID),
  postLogoutRedirectUri: getRequiredEnv(
    'OIDC_POST_LOGOUT_REDIRECT_URI',
    process.env.OIDC_POST_LOGOUT_REDIRECT_URI
  ),
  redirectUri: getRequiredEnv(
    'OIDC_REDIRECT_URI',
    process.env.OIDC_REDIRECT_URI
  ),
  scope: getRequiredEnv('OIDC_SCOPE', process.env.OIDC_SCOPE),
});
